import axios from 'axios';

import { NUTRICIONAL } from "../actions/types";

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Asesorados */
export const buscarAsesorados = (busqueda) => async dispatch => {
    if(busqueda){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const body = JSON.stringify(busqueda);

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/listar_asesorados`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.BUSCAR_ASESORADOS,
                payload: res.data.asesorias
            });
        } catch (error){ 
            await await dispatch(changeLoader(false));

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        await dispatch({
            type: NUTRICIONAL.BUSCAR_ASESORADOS,
            payload: []
        });
    }
}

export const buscarAsesores = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/nutricional/listar_asesores`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.BUSCAR_ASESORES,
            payload: res.data.asesores
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerAsesoria = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/detalles_asesoria`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.DETALLES_ASESORIA,
                payload: res.data.asesoria
            });
        } catch (error){       
            await dispatch(changeLoader(false));  

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_ASESORIA,
            payload: null
        });
    }
}

export const obtenerCompletaAsesoria = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/informacion_asesoria`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.DETALLES_ASESORIA,
                payload: res.data.asesoria
            });
        } catch (error){   
            await dispatch(changeLoader(false));      

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_ASESORIA,
            payload: null
        });
    }
}

export const obtenerMensajesAsesoria = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/listar_mensajes`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.MENSAJES_ASESORIA,
                payload: res.data.mensajes
            });
        } catch (error){     
            await dispatch(changeLoader(false));    

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_ASESORIA,
            payload: null
        });
    }
}

export const createMensajeAsesoria = (mensaje) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(mensaje);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/crear_mensaje`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.CREAR_MENSAJE,
            payload: res.data.mensaje
        });
    } catch (error){        
        await dispatch(changeLoader(false)); 

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const dietaAsesoria = (id, alimentos, asesoria) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id, 
        alimentos
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/alimentos_asesoria`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.DETALLES_ASESORIA,
            payload: {
                ...asesoria, 
                alimentos: res.data.alimentos
            }
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){     
        await dispatch(changeLoader(false));   

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

/* Notas de asesoria */
export const crearNota = (nota) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(nota);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/crear_nota`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.AGREGAR_NOTA,
            payload: res.data.nota
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerNota = (id_asesoria, id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id_asesoria, 
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/detalles_nota`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.DETALLES_NOTA,
                payload: res.data.nota
            });
        } catch (error){       
            await dispatch(changeLoader(false));  

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_NOTA,
            payload: null
        });
    }
}

export const editarNota = (nota) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(nota);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/editar_nota`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.EDITAR_NOTA,
            payload: res.data.nota
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){    
        await dispatch(changeLoader(false));    

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarNota = (id_asesoria, id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id_asesoria, 
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/eliminar_nota`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.ELIMINAR_NOTA,
            payload: body.id
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

/* Citas */
export const buscarCitas = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/listar_citas`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.BUSCAR_CITAS,
            payload: res.data.eventos
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarAsesoriasCita = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/nutricional/asesorias_citas`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.BUSCAR_ASESORADOS_CITA,
            payload: res.data.asesorias
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarHorariosCita = (id_cita, id_asesor, fecha) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        id_cita, 
        id_asesor, 
        fecha
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/horarios_citas`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.BUSCAR_HORARIOS_CITA,
            payload: res.data.horarios_disponibles
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearCita = (cita) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(cita);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/crear_cita`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.AGREGAR_CITA,
            payload: res.data.cita
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerCita = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/detalles_cita`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.DETALLES_CITA,
                payload: res.data.cita
            });
        } catch (error){       
            await dispatch(changeLoader(false));  

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_CITA,
            payload: null
        });
    }
}

export const editarCita = (cita) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(cita);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/editar_cita`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.EDITAR_CITA,
            payload: res.data.cita
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){  
        await dispatch(changeLoader(false));      

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const statusCita = (status) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(status);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/status_cita`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.EDITAR_CITA,
            payload: res.data.cita
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){      
        await dispatch(changeLoader(false));  

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarCita = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/eliminar_cita`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.ELIMINAR_CITA,
            payload: [body.id]
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const filtarCitas = (opcion) => dispatch => {
    dispatch({
        type: NUTRICIONAL.FILTROS,
        payload: opcion
    });
}

/* Bloqueos */
export const crearBloqueo = (bloqueo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(bloqueo);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/crear_bloqueo`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.AGREGAR_CITA,
            payload: res.data.bloqueo
        });

        await dispatch({
            type: NUTRICIONAL.ELIMINAR_CITA,
            payload: res.data.citas
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerBloqueo = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        
        const body = {
            id
        };

        try{
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/detalles_bloqueo`, body, config);
            await dispatch(changeLoader(false));

            await dispatch({
                type: NUTRICIONAL.DETALLES_CITA,
                payload: res.data.bloqueo
            });
        } catch (error){     
            await dispatch(changeLoader(false));    

            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        }
    }else{
        dispatch({
            type: NUTRICIONAL.DETALLES_CITA,
            payload: null
        });
    }
}

export const editarBloqueo = (bloqueo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(bloqueo);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/editar_bloqueo`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.EDITAR_CITA,
            payload: res.data.bloqueo
        });

        await dispatch({
            type: NUTRICIONAL.ELIMINAR_CITA,
            payload: res.data.citas
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){      
        await dispatch(changeLoader(false));  

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarBloqueo = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/nutricional/eliminar_bloqueo`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: NUTRICIONAL.ELIMINAR_CITA,
            payload: [body.id]
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}